import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './TiposDocumentos.css';

const TiposDocumentos = () => {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    codigo: '',
    nome: '',
    descricao: '',
    prefixo: '',
    ativo: true,
    ordem: 0
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      setLoading(true);
      const response = await api.get('/tipos-documentos?ativo=true');

      if (response.data.success) {
        setTipos(response.data.data);
      }
    } catch (err) {
      console.error('Erro ao carregar dados:', err);
      setError('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      if (editing) {
        await api.put(`/tipos-documentos/${editing.id_tipo_documento}`, formData);
        setSuccess('Tipo de documento atualizado com sucesso!');
      } else {
        await api.post('/tipos-documentos', formData);
        setSuccess('Tipo de documento criado com sucesso!');
      }

      setShowModal(false);
      setEditing(null);
      setFormData({
        codigo: '',
        nome: '',
        descricao: '',
        prefixo: '',
        ativo: true,
        ordem: 0
      });
      carregarDados();
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao salvar tipo de documento');
    }
  };

  const handleEdit = (tipo) => {
    setEditing(tipo);
    setFormData({
      codigo: tipo.codigo,
      nome: tipo.nome,
      descricao: tipo.descricao || '',
      prefixo: tipo.prefixo,
      ativo: tipo.ativo,
      ordem: tipo.ordem || 0
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este tipo de documento?')) {
      return;
    }

    try {
      await api.delete(`/tipos-documentos/${id}`);
      setSuccess('Tipo de documento excluído com sucesso!');
      carregarDados();
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao excluir tipo de documento');
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditing(null);
    setFormData({
      codigo: '',
      nome: '',
      descricao: '',
      prefixo: '',
      ativo: true,
      ordem: 0
    });
  };

  if (loading) {
    return <div className="loading-container">Carregando...</div>;
  }

  return (
    <div className="tipos-documentos-container">
      <div className="page-header">
        <h1>Tipos de Documentos</h1>
        <button className="btn-primary" onClick={() => setShowModal(true)}>
          + Novo Tipo
        </button>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Prefixo</th>
              <th>Ordem</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {tipos.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-state">
                  Nenhum tipo de documento cadastrado
                </td>
              </tr>
            ) : (
              tipos.map((tipo) => (
                <tr key={tipo.id_tipo_documento}>
                  <td><strong>{tipo.codigo}</strong></td>
                  <td>{tipo.nome}</td>
                  <td>{tipo.descricao || '-'}</td>
                  <td>{tipo.prefixo}</td>
                  <td>{tipo.ordem}</td>
                  <td>
                    <span className={`status-badge ${tipo.ativo ? 'ativo' : 'inativo'}`}>
                      {tipo.ativo ? 'Ativo' : 'Inativo'}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => handleEdit(tipo)}
                    >
                      Editar
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(tipo.id_tipo_documento)}
                    >
                      Excluir
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editing ? 'Editar' : 'Novo'} Tipo de Documento</h2>
              <button className="modal-close" onClick={handleCloseModal}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Código *</label>
                <input
                  type="text"
                  value={formData.codigo}
                  onChange={(e) => setFormData({ ...formData, codigo: e.target.value.toUpperCase() })}
                  required
                  disabled={!!editing}
                  placeholder="Ex: MEM, OF, PORT"
                />
              </div>
              <div className="form-group">
                <label>Nome *</label>
                <input
                  type="text"
                  value={formData.nome}
                  onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                  required
                  placeholder="Ex: Memorando, Ofício"
                />
              </div>
              <div className="form-group">
                <label>Descrição</label>
                <textarea
                  value={formData.descricao}
                  onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
                  rows="3"
                  placeholder="Descrição do tipo de documento"
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Prefixo *</label>
                  <input
                    type="text"
                    value={formData.prefixo}
                    onChange={(e) => setFormData({ ...formData, prefixo: e.target.value.toUpperCase() })}
                    required
                    maxLength="10"
                    placeholder="Ex: MEM"
                  />
                </div>
                <div className="form-group">
                  <label>Ordem</label>
                  <input
                    type="number"
                    value={formData.ordem}
                    onChange={(e) => setFormData({ ...formData, ordem: parseInt(e.target.value) || 0 })}
                    min="0"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.ativo}
                    onChange={(e) => setFormData({ ...formData, ativo: e.target.checked })}
                  />
                  Ativo
                </label>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn-secondary" onClick={handleCloseModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  {editing ? 'Atualizar' : 'Criar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TiposDocumentos;

